/**
 * ccm.general module
 * 
 * Description
 *
 */
'use strict';

(function ($, window) {

    var ccm = window.ccm || (window.ccm = {});

    ccm.general = (function () {

        var init = function () {

            // init flickity
            $('.js-flickity').each(function() {
                initFlickity();
            });

            // init data-href tags
            $("[data-href]").on('click', function(event) {
               event.preventDefault();
               window.location.href = $(this).attr('data-href');
            });

        };

        var initFlickity = function($element) {

            // get the flickity instance initialized via HTML
            var flkty = Flickity.data('.js-flickity');

            // check that flickity is initialized
            if (flkty == undefined) {
                setTimeout(initFlickity, 100);
                return;
            }

            if (flkty.cells.length > 1) {
                // set initial timer
                var $timer = $('.js-masthead-timer');
                var tween = TweenLite.fromTo( $timer, 8, { width: '0%'}, { width: '100%', ease: Power0.easeNone });

                flkty.on('change', function(index) {
                    //console.log( 'change: ' + index );
                
                    var $timer = $('.js-masthead-timer');
                    tween = TweenLite.fromTo( $timer, 8, { width: '0%'}, { width: '100%', ease: Power0.easeNone });
                
                    // force play even after manually change
                    flkty.playPlayer();
                });
            }

        };

        return {
            init: init
        };
    }());

    $(ccm.general.init);
}(jQuery, window));


// ------------------------------------------------------
/**
 * Primary Nav
 * 
 * Description
 *
 */
(function ($, window) {

    var ccm = window.ccm || (window.ccm = {});

    ccm.primaryNav = (function () {

        var init = function () {

            // nav mouseover handler
            $('.js-header-nav .nav-item--l1').on('mouseover', function (event) {
                openSection(event);
            });

            // nav mouseout handler
            $('.js-header-nav .nav-item--l1').on('mouseover', function (event) {
                closeSection(event);
            });

        };

        var openSection = function(event) {
            var $this = $(event.target);
            var $section = $this.find('.nav-modal');
            
            if ( !$section.hasClass('open') ) {

                // set to natural height, record, and collapse
                $section.css({'height' : 'auto'});
                var h = $section.height();
                $section.css({ 'height' : 0 });

                // open nav
                $section.addClass('open');
                TweenLite.to($section, 0.25, { height: h, ease: Power2.easeInOut, onComplete: function() {} });
            }
        };

        var closeSection = function(event) {
            var $this = $(event.target);
            var $section = $this.find('.nav-modal');
            
            // close nav
            $section.removeClass('open');
            $section.css({'height' : '0'});
        };

        return {
            init: init
        };
    }());

    $(ccm.primaryNav.init);
}(jQuery, window));


// ------------------------------------------------------
/**
 * Mobile Nav
 * 
 * Description
 *
 */
(function ($, window) {

    var ccm = window.ccm || (window.ccm = {});

    ccm.mobileNav = (function () {

        var init = function () {

            // set initial position offscreen
            resetNav();

            // set position on resize
            $(window).on('resize', function() {
                resetNav();
                closeNav();
            });

            // nav icon click handler
            $('.js-mobile-nav-trigger').on('click', function (event) {

                // nav is closed; open it
                if (!$(this).hasClass('open')) {
                    openNav();

                // nav is open; close it
                } else {
                    closeNav();
                }

            });

            // mobile nav level1 click handler
            $('.js-mobile-nav .nav-item--l1').on('click', function (event) {

                // disable event on subnav
                if (!$(event.target).is('.nav-item--l1 > a'))
                    return;

                // disable link on sections with subnav
                if ($(this).has('ul').length)
                    event.preventDefault();

                // section is closed; open it
                if (!$(this).hasClass('open')) {
                    openSection($(this));

                // section is open; close it
                } else {
                    closeSection($(this));
                }

            });

        };

        var resetNav = function () {
            $('.js-mobile-nav').css({ 
                'top': 80 - $('.js-mobile-nav').height()
            });
        };

        var openNav = function () {
            
            var $mobileNavTrigger = $('.js-mobile-nav-trigger'),
                $mobileNav = $('.js-mobile-nav');

            $mobileNavTrigger.addClass('open');
            $mobileNav.addClass('open');
            
            //$mobileNav.css({ 
            //    'top': 80
            //});
            
            TweenLite.to($mobileNav, 0.25, { top: 80, ease: Power2.easeInOut, onComplete: function() {} });
            
            //console.log('open');
        };

        var closeNav = function () {
            
            var $mobileNavTrigger = $('.js-mobile-nav-trigger'),
                $mobileNav = $('.js-mobile-nav');

            $mobileNavTrigger.removeClass('open');
            $mobileNav.removeClass('open');
            
            TweenLite.to($mobileNav, 0.25, { top: 80 - $('.js-mobile-nav').height(), ease: Power2.easeInOut, onComplete: function() {} });
            
            //console.log('close');
        };

        var openSection = function ($target) {

            var $section = $target,
                $sectionNav = $target.find('.nav-modal');

            if ( !$section.hasClass('open') ) {
                
                // set to natural height, record, and collapse
                $sectionNav.css({'height' : 'auto'});
                var h = $sectionNav.height();
                $sectionNav.css({ 'height' : 0 });

                // close any open nav sections
                $('.js-mobile-nav .nav-item--l1.open').each(function() {
                    closeSection($(this));
                });

                // open nav
                $section.addClass('open');
                TweenLite.to($sectionNav, 0.25, { height: h, ease: Power2.easeInOut, onComplete: function() {} });
            }

        };

        var closeSection = function ($target) {

            var $section = $target,
                $sectionNav = $target.find('.nav-modal');

            // close nav
            $section.removeClass('open');
            TweenLite.to($sectionNav, 0.25, { height: 0, ease: Power2.easeInOut, onComplete: function() {} });

        };

        return {
            init: init
        };
    }());

    $(ccm.mobileNav.init);
}(jQuery, window));




// ------------------------------------------------------
/**
 * Search
 * 
 * Description
 *
 */
(function ($, window) {

    var ccm = window.ccm || (window.ccm = {});

    ccm.search = (function () {

        var init = function () {

            // manage search
            $('.js-toggle-search-button').on('click', function (event) {
                toggleSearch(event);
            });

        };

        // toggle search
        var toggleSearch = function(event) {
            var $element = $('.js-search-bar');
            if ($element.hasClass('active')) {
                closeSearch();
            } else {
                openSearch();
            }
        };

        // close search
        var closeSearch = function() {
            var $element = $('.js-search-bar');
            $element.removeClass('active');
            
            // focus search field
            $element.find('.input--search').blur();
            
            // tween
            TweenLite.to($('.js-search-bar'), 0.25, { height: '0px', ease: Power2.easeInOut, onComplete: function() {} });
            
            // remove close handlers 
            $('html').off('click');
            $('.js-search-bar').off('click');
        };

        // open search 
        var openSearch = function() {
            var $element = $('.js-search-bar');
            $element.addClass('active');
            
            // blur search field
            $element.find('.input--search').focus();
            
            // tween
            TweenLite.to($('.js-search-bar'), 0.25, { height: '80px', ease: Power2.easeInOut, onComplete: function() {

                // add close handlers
                $('html').on('click', closeSearch);
                $('.js-search-bar').on('click', function(event){
                    event.stopPropagation();
                });

            } });
        };

        return {
            init: init
        };
    }());

    $(ccm.search.init);
}(jQuery, window));


/**
 * News Module
 * 
 * Provides ajax loading to news section
 *
 */
(function ($, window) {

    var ccm = window.ccm || (window.ccm = {});

    ccm.news = (function () {

        var init = function () {

            $('.js-button-view-more').on('click', function(event) {
                event.preventDefault();

                var loadNextUrl = $('.js-news-entry-group').last().data('next-url');
                console.log(loadNextUrl);

                $.ajax({
                    type: 'GET',
                    url: loadNextUrl,
                    success: function(result) {
                        // append content
                        $('.js-news-entries').append(result);
                        // check if more pages, and hide/show button
                        if ($('.js-news-entry-group').last().data('next-url').length) {
                            //console.log('next url');
                            $('.js-button-view-more').show();
                        } else {
                            //console.log('no next url');
                            $('.js-button-view-more').hide();
                        }
                    }
                });

            });

        };

        return {
            init: init
        };
    }());

    $(ccm.news.init);
}(jQuery, window));


/**
 * Modal Module
 * 
 * Description — controls modal window and signup form
 *
 */
(function ($, window) {

    var ccm = window.ccm || (window.ccm = {});

    ccm.modal = (function () {

        var init = function () {
            
            $('.js-signup-button').on('click.modal', function(event) {

                event.preventDefault();
                event.stopPropagation();

                // init form
                $('.mailing-list-form ul.errors').html('');
                $('.mailing-list-form').trigger("reset");
                $('.mailing-list-form').show();
                $('.mailing-list-thanks').hide();

                // show modal window
                $('.js-modal').fadeIn();

                // clicking anywhere closes modal + remove handlers
                $(window).on('click.modal', function(event) {
                    $('.js-modal').fadeOut();
                    $(window).off('.modal');
                    $('.modal__window').off('.modal');
                });

                // clicking on modal window prevents close (stops propagation)
                $('.modal__window').on('click.modal', function(event) {
                    event.stopPropagation();
                });

            });

            $('.mailing-list-form').on("submit", function(event) {
                event.preventDefault();

                $.ajax({
                    url: '/mailchimp/send', 
                    type: "POST", 
                    data: $(this).serialize(), 
                    dataType:"json", 
                    success: function (data) {
                        if (!data.success) {
                            // error
                            $('.mailing-list-form ul.errors').html('<li class="error">' + data.message + '</li>');
                        } else {
                            // success
                            $('.mailing-list-form').hide();
                            $('.mailing-list-thanks').show();
                        }
                    }
                });

            });

        };

        return {
            init: init
        };
    }());

    $(ccm.modal.init);
}(jQuery, window));




/**
 * Module Template
 * 
 * Description
 *
 */
(function ($, window) {

    var ccm = window.ccm || (window.ccm = {});

    ccm.module = (function () {

        var init = function () {};

        return {
            init: init
        };
    }());

    $(ccm.module.init);
}(jQuery, window));



// *************************************************
// jQuery Plug-In Utilities
// *************************************************


/* URL Encode Decode
-----------------------------------------------------------------------------*/
(function ($) {

    $.extend({
        URLEncode: function (value) {
            var output = '';
            var index = 0;
            var stringValue = value.toString();
            var matcher = /(^[a-zA-Z0-9_.]*)/;
            var match;

            while (index < stringValue.length) {
                match = matcher.exec(stringValue.substr(index));
                if (match && match.length > 1 && match[1] !== '') {
                    output += match[1];
                    index += match[1].length;
                } else {
                    if (stringValue[index] === ' ') {
                        output += '+';
                    } else {
                        var charCode = stringValue.charCodeAt(index);
                        var hex = charCode.toString(16);
                        output += '%' + (hex.length < 2 ? '0' : '') + hex.toUpperCase();
                    }
                    index++;
                }
            }

            return output;
        },
        URLDecode: function (value) {
            var output = value;
            var pattern = /(%[^%]{2})/;
            var match;
            var binValue;
            var character;

            while ((match = pattern.exec(output)) !== null && match.length > 1 && match[1] !== '') {
                binValue = parseInt(match[1].substr(1), 16);
                character = String.fromCharCode(binValue);
                output = output.replace(match[1], character);
            }

            return output;
        }
    });

    /* Reverse
    -----------------------------------------------------------------------------*/
    $.fn.reverse = [].reverse;

}(jQuery));
